import { SalesOrderComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1323. 受注案件コメント削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};
const deleteSalesOrderComment = (props: Props): Promise<SalesOrderComment> => {
  return axios.delete(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_comments/${props.id}`);
};
export const useDeleteSalesOrderComment = () => {
  return useMutation({
    mutationFn: deleteSalesOrderComment,
  });
};
